// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__D8_5L","content":"GlobalSearch_content__ByeAO"};